/**
 * Component: Scrolling Panel
 * Description: 
 *
 * Usage:
 *   - Automatically initialises on page load.
 *
 * Notes:
 * 
 */

export function scrollingPanel(scroller) {
    if (!scroller) return

    scroller.forEach((track) => {

        const content = track.querySelector('.infinite-scroll__track');

        let speed = 0.45;
        let x = 0;
        let trackWidth;

        content.append(...Array.from(content.children).map(el => el.cloneNode(true)));

        function measure() {
            trackWidth = [...content.children]
                .slice(0, content.children.length / 2)   // original only
                .reduce((sum, el) => sum + el.getBoundingClientRect().width, 0);

            // After measuring, ensure x is valid
            if (x <= -trackWidth) x += trackWidth;
        }

        measure();
        window.addEventListener("resize", measure);

        function loop() {
            x -= speed;

            if (x <= -trackWidth) {
                x += trackWidth;  // snap exactly by original width
            }
            content.style.transform = `translateX(${x}px)`;
            requestAnimationFrame(loop);
        }

        loop();

    });

}